export default {
  colorMap() {
    return {
      Black: {
        key: "Black",
        hex: "#000000",
        translationKey: "Common.Color.Black"
      },
      Blue: {
        key: "Blue",
        hex: "#01579b",
        translationKey: "Common.Color.Blue"
      },
      Brown: {
        key: "Brown",
        hex: "#4e342e",
        translationKey: "Common.Color.Brown"
      },
      Gray: {
        key: "Gray",
        hex: "#424242",
        translationKey: "Common.Color.Gray"
      },
      Green: {
        key: "Green",
        hex: "#2e7d32",
        translationKey: "Common.Color.Green"
      },
      Neutral: {
        key: "Neutral",
        hex: "#DAD8A7",
        translationKey: "Common.Color.Neutral"
      },
      Orange: {
        key: "Orange",
        hex: "#d84315",
        translationKey: "Common.Color.Orange"
      },
      Pink: {
        key: "Pink",
        hex: "#ad1457",
        translationKey: "Common.Color.Pink"
      },
      Purple: {
        key: "Purple",
        hex: "#6a1b9a",
        translationKey: "Common.Color.Purple"
      },
      Red: {
        key: "Red",
        hex: "#c62828",
        translationKey: "Common.Color.Red"
      },
      White: {
        key: "White",
        hex: "#ffffff",
        translationKey: "Common.Color.White"
      },
      Yellow: {
        key: "Yellow",
        hex: "#f9a825",
        translationKey: "Common.Color.Yellow"
      }
    };
  }
};
